import React from 'react';
import './style.scss';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';

const HeaderSearch = ({ data, className, searchOpened, setSearchOpened, setOpened }) => {
  // noinspection JSUnusedLocalSymbols
  const { searchIcon } = data;
  const openSearch = () => {
    document.getElementById('search-popup-id').classList.add('show-search-popup');
    document.body.classList.add('filter-modal-open');
    setOpened(false); //close the menu
  };
  return (
    <button
      className={clsx('search-icon-button', className)}
      onClick={(e) => {
        setSearchOpened((prev) => !prev);
        if (document.getElementById('search-popup-id').classList.contains('show-search-popup')) {
          document.getElementById('search-popup-id').classList.remove('show-search-popup');
          document.body.classList.remove('filter-modal-open');
        } else {
          openSearch(e);
        }
      }}
    >
      <div className={clsx('header-menu-icon', searchOpened && 'header-menu-icon-shifted-bottom')}>
        <SearchIcon image={searchIcon} className={className} />
      </div>
      <CloseIcon
        className={clsx(
          'header-menu-icon d-md-none',
          !searchOpened && 'header-menu-icon-shifted-top'
        )}
      />
    </button>
  );
};

const SearchIcon = ({ image, className }) => {
  if (image?.value?.src) {
    return <Image field={image} className="search-icon" />;
  }
  return (
    <div className={className}>
      <img src={'/-/media/Project/FAB2/shared/images/icon_close-white.svg'} />
    </div>
  );
};

const CloseIcon = ({ className }) => (
  <div className={className}>
    <img src={'/-/media/Project/FAB2/shared/images/icon_close-white.svg'} />
  </div>
);

export default HeaderSearch;
